import Swiper from 'swiper';
import {Pagination, Autoplay } from "swiper/modules"

export function simpleSlider() {
    document.addEventListener('DOMContentLoaded', function() {
        const swiper = new Swiper('[data-headerslider]', {
            modules: [Pagination, Autoplay],
            slidesPerView: 1,
            loop: true,
            speed: 2200,
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
              },
            autoHeight: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
              }
        });
    });
}
